import { createElement } from 'react';
import { em } from 'polished';
import { HStack, Box, Image, Button, Text } from '@chakra-ui/react';
import { ErrorPageBg, laLigaMainLogoPositiveHorizontal, LigaFErrorPageBg, ligaFLogoHorizontalBlue } from '@laliga-cdac2/assets';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DEVICE = {
  mobile: '@media(max-width: 420px)'
};
var ERROR_PAGE_THEME = {
  defaultVariant: {
    isBallDisabled: false,
    // Wrapper props
    errorPageProps: {
      bgImage: ErrorPageBg
    },
    // Body props
    contentProps: {
      logoProps: {
        src: laLigaMainLogoPositiveHorizontal,
        width: 'full',
        maxWidth: '300px'
      },
      titleProps: {
        fontFamily: 'LALIGATextPlayers',
        color: 'primaryColor.500'
      },
      subtitleProps: {
        fontFamily: 'LALIGAHeadlineRegular',
        color: 'secondaryColor.800',
        fontSize: '28px',
        fontWeight: 400
      },
      descriptionProps: {}
    }
  },
  ligaFVariant: {
    isBallDisabled: true,
    // Wrapper props
    errorPageProps: {
      bgImage: LigaFErrorPageBg,
      justifyContent: 'center',
      bgPosition: 'center 100%'
    },
    // Body props
    contentProps: {
      logoProps: {
        src: ligaFLogoHorizontalBlue,
        width: '290px',
        h: '97px'
      },
      titleProps: {
        fontFamily: 'LigaFDorsals-Regular',
        fontSize: '230.448px',
        color: 'ligaFUltraViolet.500',
        lineHeight: '251px'
      },
      subtitleProps: {
        fontFamily: 'Secondary-Light',
        color: 'primaryColor.500',
        fontWeight: 200,
        fontStyle: 'normal',
        fontSize: '28px',
        lineHeight: '32px',
        letterSpacing: '0.281835px',
        textTransform: 'uppercase'
      },
      descriptionProps: {
        fontFamily: 'Secondary-Regular',
        color: 'primaryColor.500',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '16px',
        lineHeight: '19px'
      }
    }
  }
};
var _excluded = ["backgroundSrc", "variant"],
    _excluded2 = ["bgImage"],
    _excluded3 = ["src"];
var VariantEnum;

(function (VariantEnum) {
  VariantEnum[VariantEnum["defaultVariant"] = 0] = "defaultVariant";
  VariantEnum[VariantEnum["ligaFVariant"] = 1] = "ligaFVariant";
})(VariantEnum || (VariantEnum = {}));

var ErrorPage = function ErrorPage(props) {
  var backgroundSrc = props.backgroundSrc,
      variant = props.variant,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var _ERROR_PAGE_THEME$err = ERROR_PAGE_THEME[variant || 'defaultVariant'].errorPageProps,
      bgImage = _ERROR_PAGE_THEME$err.bgImage,
      errorPageProps = _objectWithoutPropertiesLoose(_ERROR_PAGE_THEME$err, _excluded2);

  var backgroundImage = backgroundSrc || bgImage;
  return createElement(HStack, Object.assign({
    pos: "relative",
    w: "full",
    h: "100vh",
    justifyContent: "center",
    alignItems: "center",
    bgColor: "white"
  }, errorPageProps, {
    _before: {
      display: 'block',
      content: "''",
      background: "url(" + (backgroundSrc || backgroundImage) + ") no-repeat top center",
      bgSize: 'cover',
      position: 'absolute',
      width: 'full',
      height: 'full',
      opacity: '0.25',
      zIndex: 1
    },
    sx: {
      '& > *': {
        zIndex: 2
      }
    }
  }), createElement(Content, Object.assign({
    variant: variant
  }, rest)));
};

var Content = function Content(props) {
  var _sx, _sx2, _sx3;

  var logoSrc = props.logoSrc,
      code = props.code,
      title = props.title,
      description = props.description,
      children = props.children,
      buttonFunc = props.buttonFunc,
      variant = props.variant;

  var goBack = function goBack() {
    return window.location.href = '/';
  };

  var _ERROR_PAGE_THEME$con = ERROR_PAGE_THEME[variant || 'defaultVariant'].contentProps,
      titleProps = _ERROR_PAGE_THEME$con.titleProps,
      subtitleProps = _ERROR_PAGE_THEME$con.subtitleProps,
      descriptionProps = _ERROR_PAGE_THEME$con.descriptionProps,
      _ERROR_PAGE_THEME$con2 = _ERROR_PAGE_THEME$con.logoProps,
      src = _ERROR_PAGE_THEME$con2.src,
      logoProps = _objectWithoutPropertiesLoose(_ERROR_PAGE_THEME$con2, _excluded3);

  return createElement(Box, {
    textAlign: "center",
    justifyContent: "center"
  }, createElement(Image, Object.assign({
    src: logoSrc || src,
    w: "full",
    alt: "",
    m: "auto",
    marginBottom: em('50px'),
    sx: (_sx = {}, _sx[DEVICE.mobile] = {
      w: "" + em('240px')
    }, _sx)
  }, logoProps)), createElement(Box, {
    mb: em('32px'),
    textAlign: "center",
    display: "inline-flex",
    alignItems: "center"
  }, createElement(Span, Object.assign({
    fontSize: em('96px'),
    sx: (_sx2 = {}, _sx2[DEVICE.mobile] = {
      fontSize: "" + em('72px')
    }, _sx2)
  }, titleProps), code || 'oops')), createElement(Span, Object.assign({
    fontSize: em('30px'),
    textTransform: "uppercase",
    lineHeight: "1.35",
    mb: em('8px'),
    sx: (_sx3 = {}, _sx3[DEVICE.mobile] = {
      fontSize: "" + em('24px')
    }, _sx3)
  }, subtitleProps), title), createElement(Span, Object.assign({
    lineHeight: "1.45",
    marginBottom: "30px"
  }, descriptionProps), description), children || createElement(Button, {
    colorScheme: "corporateBlack",
    variant: "outline",
    onClick: buttonFunc || goBack
  }, "Volver al inicio"));
};

var Span = function Span(props) {
  return createElement(Text, Object.assign({
    color: "#25282a"
  }, props), props.children);
};

export default ErrorPage;